import { IComponentOptions, IController } from "angular";
import { IEnrichedEmployee } from "@gtmhub/employees";
import { IEnrichedTeam } from "@gtmhub/teams";

export type IStat = { value: number; suffix: string };

export type IGenericCardStats = {
  main: IStat;
  company: IStat;
  team?: IStat;
};
class GenericCardCtrl implements IController {
  title: string;
  icon: { name: string; size: string };
  stats: IGenericCardStats;
  decimalPlaces: number;
  target: IEnrichedEmployee | IEnrichedTeam;
}

export const GenericCardComponent: IComponentOptions = {
  bindings: {
    cardTitle: "@",
    icon: "<",
    stats: "<",
    target: "<",
    decimalPlaces: "<",
  },
  controller: GenericCardCtrl,
  template: require("./generic-card.component.html"),
  transclude: {
    viewDetails: "?viewDetails",
  },
};
